// src/components/client-portal/PortalRoot.jsx
// The client portal's one root element (spec 3.3). Every portal screen renders inside exactly one of these,
// so all of portal.css can be scoped under .te-portal and the CRM can never change. data-mode paints the
// page behind the solo screens navy and the app screens white.
// Module level on purpose (spec 9.8): a component declared inside ClientPortal would get a new identity on
// every render and blur the input the client is typing in.
// The first-paint styles are imported HERE, not by the portal page: App.js paints PortalLoading (and so this
// root) before the page's lazy chunk and its portal.css arrive, and without them the loading screen showed
// the office photo huge and unstyled until they did (Henry, 09/19/2026: "the photo like resizes").
import "./portalFirstPaint.css";

export default function PortalRoot({ mode, children }) {
  return (
    <div className="te-portal" data-mode={mode}>
      {children}
    </div>
  );
}
